import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';


export class PaymentFailureApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.PaymentFailure;

  constructor(private title: string, private payment: any) {
  }

  getPayload(): any {
    return {
      title: this.title,
      payment: this.payment
    };
  }
}
